"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
define('rs/form/formobjects/attach/attach.formobject.view',['rs/form/formobjects/base.formobject.view'], function (BaseFormObjectView) {
  var _BaseFormObjectView$e;
  var AttachFormObjectView = BaseFormObjectView.extend((_BaseFormObjectView$e = {
    templates: {
      'attach.formobject': 'renderFormControls',
      'attach.document': 'renderAttachmentDocument'
    },
    events: {
      'click >.form-object-contents .btn:not(.disabled)': 'handleClick',
      'keydown >.form-object-contents .btn:not(.disabled)': 'handleKeydown',
      'click >.form-object-contents .attachment-remove': 'handleRemoveAttachment',
      'mouseover >.form-object-contents .btn:not(.disabled)': 'handleFindBtnMouseOver',
      'mouseleave >.form-object-contents .btn:not(.disabled)': 'handleFindBtnMouseLeave',
      'mouseover >.form-object-contents .attachment-text': 'handleAttachedDocumentFocus',
      'keyup >.form-object-contents .attachment-text': 'handleAttachedDocumentFocus',
      'keydown >.form-object-contents .attachment-text': 'handleAttachedDocumentFocus',
      'mouseover >.form-object-contents .redactor-inline-attachment': 'handleAttachedDocumentFocus',
      'keyup >.form-object-contents .redactor-inline-attachment': 'handleAttachedDocumentFocus',
      'keydown >.form-object-contents .redactor-inline-attachment': 'handleAttachedDocumentFocus'
    },
    renderFormObjectControls: function renderFormObjectControls(templateProperties) {
      return this.renderFormControls(templateProperties);
    },
    refresh: function refresh() {
      this._super.apply(this, arguments);
      if (this.rendered) {
        this.refreshFormObjectWithValue();
      }
    }
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_BaseFormObjectView$e, "refresh", function refresh() {
    this._super.apply(this, arguments);
    if (this.rendered) {
      this.setupFormElement();
    }
  }), "hideButton", function hideButton() {
    this.$el.find('.btn-attachment-container').hide();
  }), "showButton", function showButton() {
    this.$el.find('.btn-attachment-container').show();
  }), "setupFormElement", function setupFormElement() {
    var el = this.getContentElement(),
      delegate = this.getDelegate();
    this.setFormElement(el.find('input'));
    delegate.view.$el.find(".btn-attach.btn-attachment").attr("aria-label", delegate.getText().split(/<[^>]*>/).join('') + " Attach");
    this.setAttachments(delegate.getAttachments());
    if (delegate.isReadOnly() && !delegate.isDesignerMode()) {
      this.hideButton();
    } else {
      this.showButton();
    }
  }), "setAttachButtonEnabled", function setAttachButtonEnabled(enabled) {
    if (enabled) {
      this.$(">.form-object-contents .btn").removeClass("disabled");
    } else {
      this.$(">.form-object-contents .btn").addClass("disabled");
    }
  }), "setAttachments", function setAttachments(attachmentDocuments) {
    var attachmentDisplay = this.$('.attachment-display'),
      attachment = null,
      data = null,
      newAttachEl = null;
    attachmentDisplay.empty();
    for (var i = 0, len = attachmentDocuments.length; i < len; i++) {
      attachment = attachmentDocuments[i];
      data = {
        text: attachment.getDisplayName(),
        id: i,
        url: attachment.getUrl(),
        link: attachment.getLink(),
        docstoreId: attachment.getId()
      };
      newAttachEl = this.renderAttachmentDocument(data);
      attachmentDisplay.append(newAttachEl);
    }
  }), "handleRemoveAttachment", function handleRemoveAttachment(ev) {
    var index = $(ev.currentTarget).data("attachment-id");
    this.getDelegate().requestAttachmentRemove(index);
  }), "handleKeydown", function handleKeydown(ev) {
    if (ev.keyCode === 13) {
      this.handleClick(ev);
    }
  }), "handleClick", function handleClick(ev) {
    this.getDelegate().requestAttachDocument();
  }), "handleFindBtnMouseOver", function handleFindBtnMouseOver(e) {
    var _e$target;
    var delegate = this.getDelegate();
    var buttonText = (e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.getHTML()) || "";
    if (buttonText.toLowerCase().includes('attach')) {
      delegate.view.$el.find('.btn-attach.btn-attachment').html(delegate.getText().split(/<[^>]*>/).join('') + ' Attach');
    }
  }), _defineProperty(_defineProperty(_defineProperty(_BaseFormObjectView$e, "handleFindBtnMouseLeave", function handleFindBtnMouseLeave(e) {
    var _e$target2;
    var delegate = this.getDelegate();
    var buttonText = (e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.getHTML()) || "";
    if (buttonText.toLowerCase().includes('attach')) {
      delegate.view.$el.find('.btn-attach.btn-attachment').html(' Attach');
    }
  }), "setTitleforAttached", function setTitleforAttached(className, title) {
    if (className === 'file-attachment') {
      this.getDelegate().view.$el.find('.file-attachment').attr('title', title);
    } else if (className === 'link-attachment') {
      this.getDelegate().view.$el.find('.link-attachment').attr('title', title);
    } else if (className === 'redactor-inline-attachment') {
      this.getDelegate().view.$el.find('.redactor-inline-attachment').attr('title', title);
    }
  }), "handleAttachedDocumentFocus", function handleAttachedDocumentFocus(e) {
    if ((e === null || e === void 0 ? void 0 : e.keyCode) === 9) {
      var _e$target3;
      this.setTitleforAttached(e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.className, null);
    } else {
      var _e$target4, _e$target5;
      this.setTitleforAttached(e === null || e === void 0 || (_e$target4 = e.target) === null || _e$target4 === void 0 ? void 0 : _e$target4.className, e === null || e === void 0 || (_e$target5 = e.target) === null || _e$target5 === void 0 ? void 0 : _e$target5.innerText);
    }
  })));
  return AttachFormObjectView;
});

